import { useCallback, useEffect, useState } from 'react'
import PlainItemsSelectorBox from 'app/common/ui-next/_filter-compilations/plain-items-selector-box'
import { OrderByClassesDetailsGroup } from 'app/dataTypes/reports/data/common/ordersByClasses'
import { subscibeTo } from 'app/common/data-box-store'
import { CustomerType } from 'app/dataTypes/reports/customersType'

import {
  customerTypeFilter,
  customerTypeFilterSelection,
  defaultCustomerTypeData,
  orderByClassesGroupFilterSelection,
} from 'app/dataProviders/filter-items'

const defaultCustomerTypeSelection = [CustomerType.Students]

type Props = {
  id: string
  pending: boolean
}

export const CustomerTypeFilter = ({ id, pending }: Props) => {
  const [filterVisibility, setFilterVisibility] = useState(false)

  const handleDetailsGroupFilter = useCallback((data: OrderByClassesDetailsGroup) => {
    if (data === OrderByClassesDetailsGroup.ByComplexesAndAllowances) {
      setFilterVisibility(true)
      return
    }
    setFilterVisibility(false)
  }, [])

  useEffect(() => {
    customerTypeFilter.updateData(defaultCustomerTypeData)
    customerTypeFilter.setStatusReady()
    const unsubsribeDetailsGroup = subscibeTo<OrderByClassesDetailsGroup>(
      orderByClassesGroupFilterSelection.id,
      handleDetailsGroupFilter,
    )
    return unsubsribeDetailsGroup
  }, [handleDetailsGroupFilter])

  return (
    filterVisibility && (
      <PlainItemsSelectorBox
        id={id}
        label="Тип покупателя"
        header="Выбор типа покупателя"
        dataBoxData={customerTypeFilter}
        dataBoxSelection={customerTypeFilterSelection}
        pleaseSelectText="Нет данных"
        selectedAllOnEmptySelection
        disabled={pending}
        multiple
        defaultSelection={defaultCustomerTypeSelection}
      />
    )
  )
}
